// extracted by mini-css-extract-plugin
export default {"tooltip":"styles_tooltip__5iHTq","tooltip__default":"styles_tooltip__default__rmpW2","tooltip__light":"styles_tooltip__light__Hs+RD"};